import { useSdk } from '~/sdk';

export const useCustomer = () => {
  const state = useLazyAsyncData(async () => {    return await useSdk().commerce.getCustomer();
  });

  return {
    ...state,
    isAuthenticated: computed(() => !!state.data.value),
  };
};
